import { newAxiosIns } from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    viewList: 'grid',
    status: null,
  },
  mutations: {
    UPDATE_VIEW_LIST(state, value) {
      state.viewList = value
    },
    setStatus(state, status) {
      state.status = status
    },
  },
  actions: {
    async getKycStatus({ commit }) {
      const url = '/auth/api/v1/partner/request-verification-ktp/latest-history'
      try {
        const { data } = await newAxiosIns.get(url)
        commit('setStatus', data.data.status)
        return data.data.status
      } catch (error) {
        console.error(error)
        return null
      }
    },
  },
}
